module.exports = __webpack_public_path__ + "img/27775231000204.d6016446.png";